var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from "@atom/ui-kit";
import { CURRENCIES } from "./CurrencySelect.constants";
var CurrencySelect = function (props) {
    return (_jsx(Select, __assign({ style: { width: "100%" } }, props, { children: Object.values(CURRENCIES).map(function (currency) { return (_jsx(Select.Option, { value: currency, children: currency }, currency)); }) })));
};
export default CurrencySelect;
